import UserMenu from "./user-menu"
import GlobalSearch from "../dashboard/global-search"
import AddToWorkspace from "./add-to-org"
import { Tooltip, TooltipContent, TooltipTrigger } from "@components/common/tooltip"
import { DrawerContext, useDrawer } from "@stores/drawer-store"
import { Button } from "@components/common/button"
import { BellDot, BrainIcon, InboxIcon } from "lucide-react"
import useTranslator from "@hooks/use-translator"
import { Context, useModal } from "@pma/stores/modal-store"
import { usePageContext } from "@pma/stores/page-context-store"

export function TopNavigation() {
  const { translate } = useTranslator()
  const drawer = useDrawer()
  const modal = useModal()
  const { pageTitle } = usePageContext()

  const toggleInbox = (context: DrawerContext) => {
    if (drawer.isOpen && drawer?.context === context) {
      drawer.onClose()
    } else {
      drawer.onOpen()
      drawer.setContext(context)
      return
    }
  }

  const Onclick = (context: Context) => {
    modal.onOpen()
    modal.setContext(context)
  }

  return (
    <div className='fixed left-0 right-0 top-0 z-20 hidden h-[70px] w-full items-center justify-between bg-white/90 shadow-md lg:flex'>
      {/* Page title — shown when inside a project */}
      <div className='flex-1 px-4'>
        {pageTitle && (
          <span className='text-sm font-semibold text-gray-700 truncate max-w-[300px] inline-block'>
            {pageTitle}
          </span>
        )}
      </div>
      <div className='flex items-center gap-4 px-2'>
        <Tooltip>
          <TooltipTrigger>
            <BrainIcon
              onClick={() => Onclick("ai")}
              className='mx-2 h-7 w-7 text-blue-600 hover:text-blue-300'
            />
          </TooltipTrigger>
          <TooltipContent className='flex items-center gap-1'>
            <h4>{translate("Ask Ai")}</h4>
          </TooltipContent>
        </Tooltip>
        <Tooltip>
          <TooltipTrigger>
            <AddToWorkspace />
          </TooltipTrigger>
          <TooltipContent className='flex items-center gap-1'>
            <h4>{translate("Add to workspace")}</h4>
          </TooltipContent>
        </Tooltip>
        <Tooltip>
          <TooltipTrigger>
            <GlobalSearch />
          </TooltipTrigger>
          <TooltipContent className='flex items-center gap-1'>
            <h4>{translate("Search")}</h4>
          </TooltipContent>
        </Tooltip>
        <Tooltip>
          <TooltipTrigger>
            <Button
              size={"icon"}
              variant={"ghost"}
              className='hover:bg-slate-200'
              onClick={() => toggleInbox("notifications")}
            >
              <BellDot className='mx-2 h-6 w-6 text-red-400 hover:text-red-300' />
            </Button>
          </TooltipTrigger>
          <TooltipContent className='flex items-center gap-1'>
            <h4>{translate("Notifications")}</h4>
          </TooltipContent>
        </Tooltip>
        <Tooltip>
          <TooltipTrigger>
            <Button
              size={"icon"}
              variant={"ghost"}
              onClick={() => toggleInbox("updates")}
              className='text-primary hover:bg-slate-200'
            >
              <InboxIcon />
            </Button>
          </TooltipTrigger>
          <TooltipContent className='flex items-center gap-1'>
            <h4>{translate("Updates")}</h4>
          </TooltipContent>
        </Tooltip>
        <UserMenu />
      </div>
    </div>
  )
}
